import managers from './managers'
import cities from './cities'

export default {
  development: {
    namespaced: true,
    modules: {
      managers,
      cities,
    },
  },
}
